module.exports = __webpack_public_path__ + "static/media/fb.3564b213.svg";